<template>
  <div class="flex items-center justify-between">
    <span v-if="props.success" class="text-md text-gray-700"
      >Your CSV file is ready</span
    >
    <div
      v-if="props.success"
      class="inline border-b border-link-blue text-sm text-link-blue"
      @click="
        () => {
          handleDownload(downloadUrl, fileName);
          closeToast();
        }
      "
    >
      Download
    </div>
    <div v-else>
      <span class="text-md text-bad-red">Export Failed: Please try again</span>
    </div>
    <AuxoClose @click="closeToast" />
  </div>
</template>

<script setup>
import { handleDownload } from '@/utils/dom';
import AuxoClose from '@/components/shared/ui/AuxoClose.vue';

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: value => ['success', 'error'].includes(value),
  },
  fileName: {
    type: String,
    required: true,
  },
  downloadUrl: {
    type: String,
    default: '',
  },
  closeToast: {
    type: Function,
    required: true,
  },
  toastProps: {
    type: Object,
    default: () => ({}),
  },
  success: {
    type: Boolean,
    default: true,
  },
});
</script>
